var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
/**
 * 使用 scrollToFirstError 方法就可以跳转到表单节点下的第一个有错误的 FormItem 组件。
 *
 * options:
 * 支持通过传入 options.scrollIntoViewOptions 来修改 scrollIntoView 的属性。
 */
export var scrollToFirstError = function (form, options) {
    var list = __spreadArray([form], __read(form.allChildren)).filter(function (fc) { return fc.state.error && fc.state.error.status === 'error'; })
        .map(function (fc) { var _a; return (_a = fc.state.decorator) === null || _a === void 0 ? void 0 : _a.component; })
        .filter(Boolean);
    var topList = list.map(function (ref) { return ({
        ref: ref,
        top: ref.getBoundingClientRect().top,
    }); });
    topList.sort(function (a, b) { return a.top - b.top; });
    if (topList[0]) {
        topList[0].ref.scrollIntoView(__assign({ block: 'center', behavior: 'smooth' }, options === null || options === void 0 ? void 0 : options.scrollIntoViewOptions));
    }
};
